import { createContext, useContext } from "react";

import { IDevice } from "@formant/core/model/IDevice";
import { IDeviceConfigurationDocument } from "@formant/core/model/IDeviceConfigurationDocument";
import { IDeviceDetails } from "@formant/core/model/IDeviceDetails";
import { IFilter } from "@formant/core/model/IFilter";
import { INodeGraph } from "@formant/core/model/IModuleNode";
import { IObserveLayout } from "@formant/core/model/IObserveLayout";
import { ITeleopLayout } from "@formant/core/model/ITeleopLayout";
import { IView } from "@formant/core/model/IView";
import { Uuid } from "@formant/core/model/Uuid";

export interface IViewContext {
    view?: IView;
    context?: IFilter;
    layout: ITeleopLayout;
    viewId?: string;
    deviceDetails?: IDeviceDetails;
    document?: IDeviceConfigurationDocument;
    device?: IDevice;
    onSaveLayout: (layout: IObserveLayout, filter?: IFilter) => void;
    onChangeLayout: (layout: IObserveLayout) => void;
    onChangeViewId?: (viewId: Uuid) => void;
    onRemoveModule: (moduleId: string) => void;
    commitViewSave: (view: IView) => Promise<void>;
    onRevertChanges: () => void;
    currentlyEditingNodeGraph: INodeGraph | null;
    setCurrentlyEditingNodeGraph: (graph: INodeGraph | null) => void;
    isViewFocused: boolean;
    setIsViewFocused: (isViewFocused: boolean) => void;
}

const notImplemented = (fn: string) => {
    const message = `${fn}() is not implemented.`;
    return async (): Promise<void> => {
        console.error(message);
        throw new Error(message);
    };
};

export const ViewContext = createContext<IViewContext>({
    layout: {},
    onSaveLayout: notImplemented("onSaveLayout"),
    onChangeLayout: notImplemented("onChangeLayout"),
    onRemoveModule: notImplemented("onRemoveModule"),
    commitViewSave: notImplemented("commitViewSave"),
    onRevertChanges: notImplemented("onRevertChanges"),
    currentlyEditingNodeGraph: null,
    setCurrentlyEditingNodeGraph: notImplemented(
        "setCurrentlyEditingNodeGraph",
    ),
    isViewFocused: true,
    setIsViewFocused: notImplemented("isViewFocused"),
});

export const useViewContext = () => useContext(ViewContext);
